export { default, getStaticProps } from 'containers/JoinUsPage/JoinUsPage';
